import { apm } from '@elastic/apm-rum';
import { getWithTransaction } from './get-with-transaction';
import { getApmRoutes } from './get-apm-routes';
var withTransaction = getWithTransaction(apm);
var ApmRoutes = getApmRoutes(apm);
export { withTransaction, ApmRoutes };